import { createFileRoute } from "@tanstack/react-router";
import { EnterpriseSettingsPanel } from "../components/EnterpriseSettingsPanel";

export const Route = createFileRoute("/_app/settings")({
  component: () => <EnterpriseSettingsPanel />,
});
